<div class="modal-header">
  <h5 class="modal-title">{{ title ? title : "Avviso" }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onDecline()">
    <app-toolkit-bl-icon icon="close"></app-toolkit-bl-icon>
  </button>
</div>
<div class="modal-body">
  <p>
    <app-toolkit-bl-icon
      icon="error"
      cssClass="icon icon-sm icon-warning"
    ></app-toolkit-bl-icon>
    <span className="text-info">{{ description }}</span>
  </p>
</div>
<div class="modal-footer">
  <button
    class="btn btn-outline-primary"
    type="button"
    (click)="onDecline()"
    tabindex="0"
  >
    {{ reject ? reject : "Chiudi" }}
  </button>
</div>
